module.exports = __webpack_public_path__ + "img/header.6a50163e.png";